// extracted by mini-css-extract-plugin
export var container = "Column-module--container--8859f";
export var secondary = "Column-module--secondary--7a1bb";